import { useEffect, useState } from 'react';
import { getSetting } from '../api/Services';
import dayjs from 'dayjs';

export function useSetting() {
  const [setting, setSetting] = useState({});
  const [loading, setLoading] = useState(false);
  const [reRender, setRerender] = useState(0);

  const convertToFirstDayOfMonth = (date) => {
    return dayjs(date).startOf('month').format('YYYY-MM-DD');
  };

  async function callGetSettingData() {
    setLoading(true);
    try {
      const { data } = await getSetting();
      setSetting(data.result[0]);
      const creationDate = data.result[0]?.CreationDate.split('T')[0];
      const firstDayOfMonth = convertToFirstDayOfMonth(creationDate);
      localStorage.setItem('creationDate', firstDayOfMonth);
      localStorage.setItem('timezone', data.result[0].timezone)
      localStorage.setItem('calendar', data.result[0].calendar);
      try {
        localStorage.setItem('logOutTime', String(data.result[0].logOutTime));
      } catch (e) {
        console.warn('Failed to write logOutTime to localStorage', e);
      }
      setLoading(false);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    callGetSettingData();
  }, [reRender]);

  return {
    setting,
    loading,
    setRerender,
  };
}
